import React from 'react';
import './ConfirmDialog.css';

const ConfirmDialog = ({ 
  show, 
  title, 
  message, 
  onConfirm, 
  onCancel, 
  confirmText = 'Confirmar', 
  cancelText = 'Cancelar', 
  type = 'danger', // 'danger', 'primary', 'warning'
  isLoading = false,
  inputValue = '',
  setInputValue = null,
  inputPlaceholder = '',
  inputType = 'number' // 'number' ou 'text'
}) => {

  if (!show) return null;

  return (
    <div className="cd-overlay" onClick={onCancel}>
      <div className="cd-modal" onClick={e => e.stopPropagation()}>
        <div className="cd-icon-wrap">
          {type === 'danger' && <span className="cd-icon danger">🗑️</span>}
          {type === 'warning' && <span className="cd-icon warning">⚠️</span>}
          {type === 'primary' && <span className="cd-icon primary">💡</span>}
          {type === 'aporte' && <span className="cd-icon aporte">💸</span>}
        </div>
        
        <div className="cd-content">
          <h3>{title}</h3>
          <p>{message}</p>
          
          {setInputValue && (
            <div className="cd-input-wrap">
              <input 
                type={inputType} 
                step={inputType === 'number' ? "0.01" : undefined}
                autoFocus
                placeholder={inputPlaceholder}
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
                className="cd-input"
              />

            </div>
          )}
        </div>

        <div className="cd-actions">
          <button className="cd-btn cd-btn-cancel" onClick={onCancel} disabled={isLoading}>
            {cancelText}
          </button>
          <button 
            className={`cd-btn cd-btn-${type === 'aporte' ? 'primary' : type}`} 
            onClick={onConfirm} 
            disabled={isLoading || (setInputValue && !inputValue)}
          >
            {isLoading ? '...' : confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
